import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
/**
 * 文字 字体、大小、行高
 * @param props
 */
var Image = function Image(props, ref) {
  return /*#__PURE__*/React.createElement("img", _extends({}, props, {
    ref: ref
  }));
};
var RefImage = /*#__PURE__*/React.forwardRef(Image);
RefImage.defaultProps = {
  src: 'https://img.alicdn.com/tps/TB16TQvOXXXXXbiaFXXXXXXXXXX-120-120.svg'
};
export default RefImage;